export const normalizeDealerOffers = offers => {
  if (Array.isArray(offers)) {
    return offers;
  }
  return Object.values(offers).filter(offer => offer !== undefined);
};
export const extractAppIntentCreativeFromDealerOffers = offers => {
  var _firstOffer$asset;
  const [firstOffer] = normalizeDealerOffers(offers);
  return firstOffer == null || (_firstOffer$asset = firstOffer.asset) == null ? void 0 : _firstOffer$asset.creative;
};
//# sourceMappingURL=dealer.utils.js.map